var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.975,
    height: 18.275,
    viewBox: "0 0 23.975 18.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discord",
    transform: "translate(0 -5.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(-0.001 5.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M20.3,7.2a19.82,19.82,0,0,0-4.88-1.515.075.075,0,0,0-.078.037,13.671,13.671,0,0,0-.608,1.248,18.266,18.266,0,0,0-5.481,0,12.374,12.374,0,0,0-.617-1.248.076.076,0,0,0-.078-.037A19.684,19.684,0,0,0,3.672,7.2a.061.061,0,0,0-.031.027A20.236,20.236,0,0,0,.1,20.875a.084.084,0,0,0,.031.055,19.893,19.893,0,0,0,5.986,3.027.075.075,0,0,0,.084-.028,14.263,14.263,0,0,0,1.226-1.991.075.075,0,0,0-.015-.088.076.076,0,0,0-.027-.016,13.3,13.3,0,0,1-1.87-.892.075.075,0,0,1-.03-.1.076.076,0,0,1,.022-.028c.126-.094.252-.193.372-.292a.075.075,0,0,1,.076-.01,14.173,14.173,0,0,0,12.049,0,.078.078,0,0,1,.079.01c.12.1.246.2.372.292a.076.076,0,0,1-.006.127,12.368,12.368,0,0,1-1.872.89.075.075,0,0,0-.045.045.078.078,0,0,0,0,.061,15.936,15.936,0,0,0,1.224,1.991.075.075,0,0,0,.084.028,19.832,19.832,0,0,0,6-3.027.073.073,0,0,0,.031-.055A20.093,20.093,0,0,0,20.326,7.23.051.051,0,0,0,20.3,7.2ZM8.012,18.151a2.3,2.3,0,0,1-2.155-2.415,2.292,2.292,0,0,1,2.155-2.417,2.28,2.28,0,0,1,2.155,2.417A2.292,2.292,0,0,1,8.012,18.151Zm7.966,0a2.3,2.3,0,0,1-2.155-2.415,2.292,2.292,0,0,1,2.155-2.417,2.279,2.279,0,0,1,2.155,2.417A2.286,2.286,0,0,1,15.978,18.151Z",
    transform: "translate(0.001 -5.686)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.63fdb8116812b5950fb29393ddb32ddc.svg";
export { ForwardRef as ReactComponent };